import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function quizSubcategoryDataReducer(state = initialState.quizSubcategoryData, action) {
  switch (action.type) {
    case types.LOADED_QUIZ_SUBCATEGORY_DATA_SUCCESS:
      return action.quizSubcategoryData;
    default:
      return state;
  }
} 
